import React, { useState, useEffect } from "react";
import { getStoreObj } from "../utils/storage"; // Функция для получения данных из localStorage
import "../styles/StoreInfo.css"; // Подключение стилей

const StoreInfo = ({ totalPrice, store = null }) => {
    const [storeObj, setStoreObj] = useState(null);

    useEffect(() => {
        if (store === null) {
            setStoreObj(getStoreObj()); // Получаем данные о магазине из localStorage
        } else {
            setStoreObj(store);
        }
    }, [store]); // Этот эффект сработает только при изменении `store`

    //console.log("StoreInfo storeObj", storeObj);

    //TODO make store_logo
    if (!storeObj || !storeObj.network_name || !storeObj.address) {
        // Если информации о магазине нет, ничего не отображаем
        return (
            <div>
                <p>Сталася помилка, спробуйте ще раз</p>
            </div>
        );
    }

    const storeLogo = storeObj.store_logo || "/images/default_shop_logo.svg";
    //console.log("StoreInfo storeLogo", storeLogo);

    return (
        <div className="store-info">
            <div className="store-info__left">
                <img
                    src={storeLogo}
                    alt={`${storeObj.network_name} logo`}
                    className="store-info__logo"
                />
                <div className="store-description">
                    <h2>{storeObj.network_name}</h2>
                    <p>{storeObj.address}</p>
                </div>
            </div>
            <div>
                {totalPrice !== undefined && (
                    <div className="store-info__price">{totalPrice} грн</div>
                )}
            </div>
        </div>
    );
};

export default StoreInfo;
